import { Box, styled } from '@mui/material'

export const Footer = styled(Box)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0px -1px 4px 0px #0000000D',
  padding: theme.spacing(1),
  zIndex: 1,
  height: '50px',
}))
